import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { UserCard } from '../../UserCard/UserCard';
import { PinButton, SidebarBase } from '../common';
import { DefaultSidebarLogo } from './DefaultSidebarLogo';
import { SidebarNavigation } from './SidebarNavigation';

export const Sidebar: FC = () => {
  return (
    <SidebarBase>
      {({ onPinClick, pinButtonRef }) => (
        <>
          <div className='flex size-full flex-col'>
            <DefaultSidebarLogo
              titleClassName={twMerge(
                'hidden h-full shrink-0',
                'transition-discrete starting:opacity-0 motion-safe:delay-200 motion-safe:duration-500 ',
                'group-data-[expanded=true]/sidebar:block'
              )}
            />
            <PinButton ref={pinButtonRef} onClick={onPinClick} classNames={{ button: 'my-4' }} />
            <SidebarNavigation />
          </div>
          <UserCard />
        </>
      )}
    </SidebarBase>
  );
};
